export default __webpack_public_path__ + "static/media/en.35c955fc.svg";